<template>
	<v-content>
		<v-container width="100%" ml-auto mr-auto pl-0 pr-0 pb-3 style="padding-top: 150px;">
			<v-layout row wrap>
      			<v-flex xs12 mb-4>
					<div class="not-found-title text-xs-center">404</div>
      			</v-flex>
      			<v-flex xs12 mb-2>
					<div class="main-subtitle text-xs-center">{{ $lib.translate('Страница не найдена') }}</div>
      			</v-flex>
      			<v-flex xs12>
					<div class="search-now ml-auto mr-auto">
						<router-link class="search-now__button" to="/search">
							<div class="search-now__button-text">{{ $lib.translate('Перейти к поиску') }}</div>
							<div class="search-now__button-ico">
								<v-icon size="22" color="primary">search</v-icon>
							</div>
						</router-link>
					</div>
      			</v-flex>
			</v-layout>
		</v-container>
  	</v-content>
</template>

<script>
export default {
	name: '404'
}
</script>

<style lang="scss">
	.search-now {
		width: 604px;
		height: 331px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;

		&__bg {
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}

		&__button {
			position: relative;
			z-index: 5;
			width: 291px;
			height: 60px;
			background: #42B0EB;
			border-radius: 70px;
			font-family: var(--secondaryFontFamily);
			font-size: 16px;
			line-height: 100%;
			letter-spacing: 0.05em;
			text-transform: uppercase;
			color: #FFFFFF;
			display: flex;
			align-items: center;
			padding: 6px;
			padding-left: 40px;
			justify-content: center;
			box-sizing: border-box;
			border: 2px solid #42B0EB;
			text-decoration: none;
			transition: background 0.2s ease, color .2s;
			margin-right: 5px;
			cursor: pointer;

			&:hover {
				background: rgba(#fff, .6);
				color: #082c4c;
			}
		}

		&__button-ico {
			width: 48px;
			height: 48px;
			display: flex;
			justify-content: center;
			align-items: center;
			background-color: #fff;
			border-radius: 100%;
			margin-left: auto;
		}
	}

	.not-found-title {
		font-style: normal;
		font-weight: bold;
		font-size: 100px;
		line-height: 63px;
		color: #082c4c;
	}

	.main-subtitle {
		font-style: normal;
		font-weight: bold;
		font-size: 36px;
		line-height: 44px;
		color: #082c4c;
	}
</style>
